<template>
    <button
        v-tippy="t('editorToggleHeaderRow')"
        :class="[buttonState(editor.can().toggleHeaderRow()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().toggleHeaderRow()"
        @click="editor.chain().focus().toggleHeaderRow().run()"
    >
        <MdiTableRow class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableRow from 'materialdesignicons-vue3/icons/MdiTableRow.js';

    defineExpose({
        name: 'TableToggleHeaderRowButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
